module.exports = __webpack_public_path__ + "img/s-hd.0a3d2a70.jpg";